
<template>
    <div>
      <div class="row gy-2">
        <div class="col-12">
          <h5 class="mb-3">Your attendance records for this program</h5>
          <div class="row gy-2 justify-content-between">
            <div class="col-sm-12 col-md-5 col-lg-4 d-flex">
              <div class="input-group">
                <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage" :options="pageOptions"></b-form-select>
              </div>
            </div>
            <div class="col-sm-12 col-md-5">
              <div class="input-group mb-0">
                <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control" placeholder="Search here..." aria-label="Search here..." aria-describedby="button-search_TB">
                <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span class="ri ri-search-line"></span></button>
              </div>
            </div>
          </div>
          <div class="my-3">
            <p class="mb-0">Showing {{paginationInfo}} results</p>
          </div>
          <div class="card">
            <div class="card-body p-lg-3">
              <div class="table-responsive mb-0 loading-viewport">
                <is-loading v-if="isLoading" :box="true" />
                <b-table striped hover ref="selectableTable" :items="pageData.data"
                  :fields="columns" responsive="sm" align="middle">
                  <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                    v-slot:[`head(${column.key})`] >
                      <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                      d-flex align-items-center">
                        {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                      </div>
                  </template>
                  <template v-slot:cell(program)="data">
                  <div style="min-width:10rem;" 
                    v-if="data.item.program" class="cursor-pointer">
                    {{ data.item.program.title }}
                  </div>
                </template>
                  <template v-slot:cell(checkedin_at)="data">
                    <div style="width:15rem;" class="cursor-pointer">
                      {{ $filters.date(data.item.checkedin_at, 1) }}
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <b-pagination v-model="currentPage" :limit="4" class="pagination-rounded"
            :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import IsLoading from '@/components/IsLoading.vue'
  import _ from 'lodash';
  import { commonSortingMixin } from '@/mixins/commonSortingMixin';
  import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';
  
  export default {
    name: "training-attendances",
    mixins: [
      commonSortingMixin,
      commonPaginationMixin,
    ],
    components:{
      IsLoading,
    },
    props:{
      enrollment: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        isLoading: true,
        searchQuery:"",

        columns: [
          {
            key: "program",
            label: "Training Program",
          }, 
          {
            key: "checkedin_at",
            label: "Checked In",
            sortable: true
          }, 
        ],
        sortBy: {
          sort_column: "checkedin_at",
          sort_direction: "desc"
        },
        pageData:{
          data: []
        },
      }
    },
    methods: {
      updateSearchQuery: _.debounce(function(string) {
        this.fetchItems()
      }, 2000),
      fetchItems(page, per_page = null){
        let payload = {page: page || 1, per_page: per_page || this.itemsPerPage,
          ...this.sortBy, training_enrollment_id: this.enrollment.id
        }

        if(this.searchQuery){ payload.search = this.searchQuery }
  
        this.isLoading = true
        this.$http.get(`/attendances?${new URLSearchParams(payload).toString()}`)
          .then((response) => {
            this.isLoading = false
            if(response.data.success){
              this.pageData = response.data.data
            }
          })
      },
      initializeAll(){
      },
    },
    created() {
      this.fetchItems()
    }
  }
  
  </script>
  
  